import script from "./HeroFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroFrame.vue?vue&type=script&setup=true&lang=ts"

import "./HeroFrame.vue?vue&type=style&index=0&id=3e516d3a&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e516d3a"]])

export default __exports__